<template>
  <div>
    <v-row>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
      >
        <ValidationProvider name="Service ID" rules="allowHash|min:4" v-slot="{ errors }" immediate>
          <v-text-field
            label="Service ID "
            placeholder=" "
            outlined
            persistent-hint
            v-model="userService.serviceId"
            autocomplete="off"
            color="dark"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
      >
        <ValidationProvider
          name="Username"
          rules="required|noSpecialChars|radiusUsername"
          v-slot="{ errors }"
          immediate
        >
          <v-text-field
            label="Username *"
            placeholder=" "
            outlined
            persistent-hint
            v-model="userService.radiusUsername"
            :error="checkStatus(userService.radiusUsername)"
            :error-messages="isRadiusUsernameExisting ? `${userService.radiusUsername} already exist` : errors"
            autocomplete="off"
            color="dark"
            @input="checkUsername()"
            :readonly="!isAdding"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
      >
        <ValidationProvider
          name="Password"
          rules="required|min:4|noWhitespace"
          immediate
          v-slot="{ errors }"
        >
          <v-text-field
            label="Password *"
            placeholder=" "
            outlined
            persistent-hint
            @click:append="showPassword = !showPassword"
            :error="checkStatus(userService.radiusPassword)"
            v-model="userService.radiusPassword"
            :error-messages="errors"
            autocomplete="off"
            color="dark"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'pb-8 pt-0' : 'py-1'"
        v-if="!isAdding"
      >
        <ValidationProvider name="Master Service" immediate>
          <v-autocomplete
            class="mr-1"
            prepend-inner-icon="mdi-magnify"
            v-model="userService.masterServiceId"
            hide-no-data
            hide-details
            clearable
            label="Master Service"
            :items="masterServices"
            :item-text="itemText"
            item-value="id"
            :search-input.sync="searchMasterService"
          ></v-autocomplete>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
        v-show="false"
      >
        <ValidationProvider name="Shape" immediate>
          <v-combobox
            v-model="userService.radiusShape"
            :items="shapes"
            label="Shape "
            outlined
            persistent-hint
            placeholder=" "
            color="dark"
          ></v-combobox>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
        v-if="!isAdding"
      >
        <v-text-field
          label="Static IP"
          placeholder=" "
          outlined
          persistent-hint
          v-model="userService.radiusStaticIp"
          autocomplete="off"
          color="dark"
          disabled
          readonly
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
        v-if="!isAdding && (userService.ipRange != null || userService.ipRange !== '')"
      >
        <v-text-field
          label="Static IP Range"
          placeholder=" "
          outlined
          persistent-hint
          v-model="userService.ipRange"
          autocomplete="off"
          color="dark"
          disabled
          readonly
        ></v-text-field>
      </v-col>
      <!-- <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
      >
        <ValidationProvider name="Rateplan" :rules="isAdding ? 'required' : ''" v-slot="{ errors }" immediate>
          <v-autocomplete
            v-model="userService.ratePlanId"
            :items="rateplans"
            label="Rate Plan "
            outlined
            persistent-hint
            placeholder=" "
            color="dark"
            clearable
            :error-messages="errors"
            item-text="ratePlanDescription"
            item-value="ratePlanID"
          ></v-autocomplete>
        </ValidationProvider>
      </v-col> -->

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
        v-show="false"
      >
        <ValidationProvider name="IP Group" v-slot="{ errors }" immediate>
          <v-combobox
            v-model="userService.ipGroup"
            :items="ipGroups"
            label="IP Group"
            outlined
            persistent-hint
            placeholder=" "
            :disabled="isAdding"
            color="dark"
            clearable
            :error-messages="errors"
            item-text="ip_group"
            item-value="ip_group"
            @change="$emit('get-ip', userService.ipGroup)"
            :return-object="false"
          ></v-combobox>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6"
        :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'"
      >
        <div style="display: inline-block; font-size: 16px" class="mr-7">
          Network Protocol
        </div>
        <v-radio-group
          v-model="userService.isIPoE"
          row
          outlined
          style="display: inline-block"
          autocomplete="off"
          disabled
          readonly
        >
          <v-radio label="IPoE" :value="true"></v-radio>
          <v-radio label="PPPoE" :value="false"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="12" md="6" :class="$vuetify.breakpoint.smAndDown ? 'py-0' : 'py-1'">
            <v-checkbox v-model="userService.sellToUB" :label="`Service ${userService.serviceId} will also be sold to organisation's billing platform`"></v-checkbox>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import { debounce } from "vue-debounce";

export default {
  name: "user-service",
  props: {
    isAdding: { type: Boolean, required: true },
    userService: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  data: () => ({
    getIP: false,
    masterServices: [],
    searchMasterService: null,
    showPassword: false,
    selectedIP: "",
    shapes: [
      "Shape12Mbps",
      "Shape25Mbps",
      "Shape50Mbps",
      "Shape100Mbps",
      "Shape256Kbps",
    ],
    isRadiusUsernameExisting: false
  }),
  methods: {
    checkUsername() {
      let vm = this;
      if(vm.userService.radiusUsername === null ||
        vm.userService.radiusUsername.length <= 0 ||
        !vm.userService.radiusUsername.trim()) {
        vm.isRadiusUsernameExisting = false
        vm.$emit('existingUsername', vm.isRadiusUsernameExisting)
      } else {
        vm.checkRadiusUsername(vm.userService.radiusUsername).then((data) => {
          vm.isRadiusUsernameExisting = data;
          vm.$emit('existingUsername', vm.isRadiusUsernameExisting)
        });
      }
    },
    checkStatus(data) {
      if (data) return false;
      else return true;
    },
    itemText(item) {
      return `${item.serviceDescription} ($${item.priceRate})`;
    },
    emitIpGroup() {
      let vm = this;
      vm.$emit("ipGroupUpdated", vm.selectedIP);
    }
  },
  watch: {
    searchMasterService(val) {
      let vm = this;
      if (val.toString().includes("(")) return;
      if (val)
        debounce(() => {
          vm.getMasterServices({ search: val }).then((data) => {
            vm.masterServices = data;
          });
        }, 300)(val);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
